import {
    assignCurrentUserToGroup,
    reassignCurrentUserToGroups,
    removeCurrentUserFromGroup,
} from "@allwyn/ng/exponea/exponea-groups";
import { useExponeaFloatingById } from "@sazka/casino/js/floating/use-floating";

const expose = (name: string, method: (...args: any[]) => any) => {
    window.sazka.exponea[name] = method;
};

const showFloatingElement = (id: number) => {
    useExponeaFloatingById(id);
};

const registerExponeaToWindow = (): void => {
    window.sazka = window.sazka || {};
    window.sazka.exponea = window.sazka.exponea || {};
    expose("showFloatingElement", showFloatingElement);
    expose("assignCurrentUserToGroups", reassignCurrentUserToGroups);
    expose("assignCurrentUserToGroup", assignCurrentUserToGroup);
    expose("removeCurrentUserFromGroup", removeCurrentUserFromGroup);
};

export const useExponea = () => ({
    registerExponeaToWindow,
    expose,
});
